import axios from "../api";

export const updatedNotificationsStatusAction = async (id) => {
    return new Promise((resolve, reject) => {
        axios
            .post(`/notification`, { id })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

// Fetch all notifications for a user
export const fetchUserNotificationsAction = async (userId, status = "all") => {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/notification/${userId}`, {
                params: { status },
            })
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};

// Mark a notification as read
export const markNotificationAsReadAction = async (notificationId) => {
    return new Promise((resolve, reject) => {
        axios
            .put(`/api/notification/mark-read/${notificationId}`, {})
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
};
